import { EsgDataType } from './enums/EsgDataType'

import type { ActionStatus } from '@/constants/enums/BuyerImprovementPlan'
import type { InferNumber } from '@/utils/number'

import { strictObjectEntries } from '@/utils/object'
import { EsgDataStatus } from '@/constants/enums/EsgDataStatus'

// common.ts
const INDUSTRY_TYPE_1 = 'common.industry.type_1'
const INDUSTRY_TYPE_2 = 'common.industry.type_2'
const INDUSTRY_TYPE_3 = 'common.industry.type_3'
const INDUSTRY_TYPE_4 = 'common.industry.type_4'
const INDUSTRY_TYPE_5 = 'common.industry.type_5'
const INDUSTRY_TYPE_6 = 'common.industry.type_6'
const INDUSTRY_TYPE_7 = 'common.industry.type_7'
const INDUSTRY_TYPE_8 = 'common.industry.type_8'
const INDUSTRY_TYPE_9 = 'common.industry.type_9'
const INDUSTRY_TYPE_10 = 'common.industry.type_10'
const INDUSTRY_TYPE_11 = 'common.industry.type_11'
const INDUSTRY_TYPE_12 = 'common.industry.type_12'
const INDUSTRY_TYPE_13 = 'common.industry.type_13'
const INDUSTRY_TYPE_14 = 'common.industry.type_14'
const INDUSTRY_TYPE_15 = 'common.industry.type_15'
const INDUSTRY_TYPE_16 = 'common.industry.type_16'
const INDUSTRY_TYPE_17 = 'common.industry.type_17'
const INDUSTRY_TYPE_18 = 'common.industry.type_18'
const INDUSTRY_TYPE_19 = 'common.industry.type_19'
const INDUSTRY_TYPE_20 = 'common.industry.type_20'
const INDUSTRY_TYPE_21 = 'common.industry.type_21'
const INDUSTRY_TYPE_22 = 'common.industry.type_22'
const INDUSTRY_TYPE_23 = 'common.industry.type_23'
const INDUSTRY_TYPE_24 = 'common.industry.type_24'
const INDUSTRY_TYPE_25 = 'common.industry.type_25'
const INDUSTRY_TYPE_26 = 'common.industry.type_26'

const SCALE_A = 'common.scale.a'
const SCALE_B = 'common.scale.b'
const SCALE_C = 'common.scale.c'
const SCALE_D = 'common.scale.d'
const SCALE_E = 'common.scale.e'
const SCALE_F = 'common.scale.f'

const EVALUATION_STATUS_1 = 'common.answer_display_status.unanswered'
const EVALUATION_STATUS_2 = 'common.answer_display_status.temporarily_saved'
const EVALUATION_STATUS_3 = 'common.answer_display_status.submitted'
const EVALUATION_STATUS_4 = 'common.answer_display_status.score_rated'
const EVALUATION_STATUS_5 = 'common.answer_display_status.ended'

const IMPROVEMENT_PLAN_ACTION_STATUS_1 = 'improvementplans.unsupported'
const IMPROVEMENT_PLAN_ACTION_STATUS_2 = 'improvementplans.currently_supporting'
const IMPROVEMENT_PLAN_ACTION_STATUS_3 = 'improvementplans.supported'

const ESG_DATA_SHARING_STATUS_1 = 'common.esg_data_display_status.sharing'
const ESG_DATA_SHARING_STATUS_2 = 'common.esg_data_display_status.inviting'
const ESG_DATA_SHARING_STATUS_3 = 'common.esg_data_display_status.unshared'

const ESG_DATA_SHARED_STATUS_1 = 'common.esg_data_display_status.viewable'
const ESG_DATA_SHARED_STATUS_2 = 'common.esg_data_display_status.unviewable'

const ESG_DATA_ANSWERING_STATUS_1 = 'common.answer_display_status.temporarily_saved'
const ESG_DATA_ANSWERING_STATUS_2 = 'common.esg_data_display_status.sharing'

const ESG_DATA_TYPE_DESCRIPTION_1 = 'esg_data.create_data_modal.standard_explain'
const ESG_DATA_TYPE_DESCRIPTION_2 = 'esg_data.create_data_modal.enter_prise_explain'

const BUYER_CREATE_QUESTION_GROUP_ANSWER_STATUS_1 = 'common.answer_display_status.unanswered'
const BUYER_CREATE_QUESTION_GROUP_ANSWER_STATUS_2 = 'common.answer_display_status.temporarily_saved'
const BUYER_CREATE_QUESTION_GROUP_ANSWER_STATUS_3 = 'common.answer_display_status.submitted'

// setting.ts
export const ACCOUNT_SETTINGS_TITLE = 'settings.account_related'

export const ALIGNMENTS = {
  left: 'start',
  center: 'center',
  right: 'end',
}
export const ORDERING = {
  ascending: 'asc',
  descending: 'desc',
}
export const COMPLETIONSTATUS = {
  done: 2,
  inprogress: 1,
  notstarted: 0,
} as const
export type CompletionStatus = typeof COMPLETIONSTATUS[keyof typeof COMPLETIONSTATUS]

export const PrefectureName = {
  1: '北海道',
  2: '青森県',
  3: '岩手県',
  4: '宮城県',
  5: '秋田県',
  6: '山形県',
  7: '福島県',
  8: '茨城県',
  9: '栃木県',
  10: '群馬県',
  11: '埼玉県',
  12: '千葉県',
  13: '東京都',
  14: '神奈川県',
  15: '新潟県',
  16: '富山県',
  17: '石川県',
  18: '福井県',
  19: '山梨県',
  20: '長野県',
  21: '岐阜県',
  22: '静岡県',
  23: '愛知県',
  24: '三重県',
  25: '滋賀県',
  26: '京都府',
  27: '大阪府',
  28: '兵庫県',
  29: '奈良県',
  30: '和歌山県',
  31: '鳥取県',
  32: '島根県',
  33: '岡山県',
  34: '広島県',
  35: '山口県',
  36: '徳島県',
  37: '香川県',
  38: '愛媛県',
  39: '高知県',
  40: '福岡県',
  41: '佐賀県',
  42: '長崎県',
  43: '熊本県',
  44: '大分県',
  45: '宮崎県',
  46: '鹿児島県',
  47: '沖縄県',
} as const

export const CompanyScale = {
  1: '1〜29人',
  2: '30〜99人',
  3: '100〜499人',
  4: '500〜999人',
  5: '1000〜4999人',
  6: '5000人〜',
} as const

export const IndustryType = {
  1: INDUSTRY_TYPE_1,
  2: INDUSTRY_TYPE_2,
  3: INDUSTRY_TYPE_3,
  4: INDUSTRY_TYPE_4,
  5: INDUSTRY_TYPE_5,
  6: INDUSTRY_TYPE_6,
  7: INDUSTRY_TYPE_7,
  8: INDUSTRY_TYPE_8,
  9: INDUSTRY_TYPE_9,
  10: INDUSTRY_TYPE_10,
  11: INDUSTRY_TYPE_11,
  12: INDUSTRY_TYPE_12,
  13: INDUSTRY_TYPE_13,
  14: INDUSTRY_TYPE_14,
  15: INDUSTRY_TYPE_15,
  16: INDUSTRY_TYPE_16,
  17: INDUSTRY_TYPE_17,
  18: INDUSTRY_TYPE_18,
  19: INDUSTRY_TYPE_19,
  20: INDUSTRY_TYPE_20,
  21: INDUSTRY_TYPE_21,
  22: INDUSTRY_TYPE_22,
  23: INDUSTRY_TYPE_23,
  24: INDUSTRY_TYPE_24,
  25: INDUSTRY_TYPE_25,
  26: INDUSTRY_TYPE_26,
} as const

export const CompanyScaleType = {
  1: SCALE_A,
  2: SCALE_B,
  3: SCALE_C,
  4: SCALE_D,
  5: SCALE_E,
  6: SCALE_F,
} as const

export const SupplierEvaluationStatusType = {
  1: EVALUATION_STATUS_1,
  2: EVALUATION_STATUS_2,
  3: EVALUATION_STATUS_3,
  4: EVALUATION_STATUS_4,
  5: EVALUATION_STATUS_5,
} as const

export const BuyerEvaluationStatusType = {
  1: EVALUATION_STATUS_1,
  2: EVALUATION_STATUS_2,
  3: EVALUATION_STATUS_3,
  4: EVALUATION_STATUS_4,
  5: EVALUATION_STATUS_5,
} as const

export const ImprovementPlanActionStatusType = {
  1: IMPROVEMENT_PLAN_ACTION_STATUS_1,
  2: IMPROVEMENT_PLAN_ACTION_STATUS_2,
  3: IMPROVEMENT_PLAN_ACTION_STATUS_3,
} as const satisfies { [key in ActionStatus]: string }

export const BuyerCreateQuestionGroupAnswerStatusType = {
  1: BUYER_CREATE_QUESTION_GROUP_ANSWER_STATUS_1,
  2: BUYER_CREATE_QUESTION_GROUP_ANSWER_STATUS_2,
  3: BUYER_CREATE_QUESTION_GROUP_ANSWER_STATUS_3,
} as const

const PriorityTypeAdmin = {
  0: '良好',
  1: '高',
  2: '中',
  3: '低',
  4: 'なし',
} as const

export const IndustryTypeAdmin = {
  1: '農林水産業',
  2: '鉱業・採石業・砂利採取業',
  3: '建設業（設備工事業を含む）',
  4: '製造業（鉄鋼・非鉄金属・金属製品）',
  5: '製造業（機械器具・電子機器等）',
  6: '製造業（食品・飲料・たばこ等）',
  7: '製造業（パルプ・紙・紙加工品）',
  8: '製造業（木材・木製品等加工）',
  9: '製造業（化学工業（医薬品を含む）・繊維工業）',
  10: '製造業（石油・石炭・ゴム・プラスチック等）',
  11: '製造業（印刷業）',
  12: '製造業（その他）',
  13: '電気・ガス・熱供給・水道業',
  14: '情報通信業',
  15: '運輸業・倉庫業',
  16: '卸売業・小売業',
  17: '金融業・保険業',
  18: '不動産業',
  19: '学校（幼稚園・保育園等を含む）',
  20: '宿泊業・飲食サービス業',
  21: '生活関連サービス業（洗濯・理容・美容・浴場業等）',
  22: '医療・福祉',
  23: '廃棄物処理業・リサイクル業',
  24: '自動車整備業',
  25: '自治体・行政機関等',
  26: 'その他',
} as const

export const EnvironmentCategoryNames = {
  'ja': '環境',
  'en': 'Environment',
  'zh-CN': '环境',
  'zh-TW': '環境',
  'es': 'Medioambiente',
  'th': 'สภาพแวดล้อม',
  'vi': 'Môi trường',
  'ko': '환경',
  'fr': 'Environnement',
  'de': 'Umwelt',
  'id': 'Lingkungan',
}
export const SocietyCategoryNames = {
  'ja': '社会',
  'en': 'Social',
  'zh-CN': '社会',
  'zh-TW': '社會',
  'es': 'Social',
  'th': 'โซเชียล',
  'vi': 'Xã hội',
  'ko': '사회',
  'fr': 'Social',
  'de': 'Soziales',
  'id': 'Sosial',
}
export const GovernanceCategoryNames = {
  'ja': 'ガバナンス',
  'en': 'Governance',
  'zh-CN': '管理',
  'zh-TW': '治理',
  'es': 'Gobernanza',
  'th': 'ธรรมาภิบาล',
  'vi': 'Quản trị',
  'ko': '거버넌스',
  'fr': 'Gouvernance',
  'de': 'Governance',
  'id': 'Tata Kelola',
}
export const cloneEnvironmentCategoryNames = () => ({ ...EnvironmentCategoryNames })
export const cloneSocietyCategoryNames = () => ({ ...SocietyCategoryNames })
export const cloneGovernanceCategoryNames = () => ({ ...GovernanceCategoryNames })

export const SUSTAINA_RATINGS = {
  1: 'AAA',
  2: 'AA',
  3: 'A',
  4: 'BBB',
  5: 'BB',
  6: 'B',
  7: 'CCC',
} as const

export const COMPANY_RELATION = {
  buyer: 1,
  supplier: 2,
  myself: 3,
} as const

export const ESG_DATA_TYPE = {
  1: {
    key: EsgDataType.ESG_STANDARD,
    title: 'Standard',
    description: ESG_DATA_TYPE_DESCRIPTION_1,
    questionCount: 73,
  },
  2: {
    key: EsgDataType.ESG_ENTERPRISE,
    title: 'Enterprise',
    description: ESG_DATA_TYPE_DESCRIPTION_2,
    questionCount: 161,
  },
} as const

export const ESG_DATA_SHARING_STATUS = {
  SHARING: ESG_DATA_SHARING_STATUS_1,
  INVITING: ESG_DATA_SHARING_STATUS_2,
  UNSHARED: ESG_DATA_SHARING_STATUS_3,
}

export const ESG_DATA_SHARED_STATUS = {
  SHARING: ESG_DATA_SHARED_STATUS_1,
  UNSHARED: ESG_DATA_SHARED_STATUS_2,
}

export const ESG_DATA_ANSWERING_STATUS = {
  ANSWERING: ESG_DATA_ANSWERING_STATUS_1,
  SHARING: ESG_DATA_ANSWERING_STATUS_2,
}

/**
 * 各constをリストにする
 */
type Options = {
  title: string
  value: number
}[]
export const scaleOptions: Options = Object.entries(CompanyScale).map(
  ([key, value]) => {
    return { value: Number(key), title: value }
  },
)
// TODO: 調査票/サーベイリストは一旦トルツメ、実装後に作成
// export const questionOptions: Options = [{ title: 'すべて', value: 0 }]
export const industryOptions: Options = Object.entries(IndustryType).map(
  ([key, value]) => {
    return { value: Number(key), title: value }
  },
)
export const companyScaleOptions: Options = Object.entries(
  CompanyScaleType,
).map(([key, value]) => {
  return { value: Number(key), title: value }
})

export const SupplierEvaluationStatusOptions: Options = Object.entries(
  SupplierEvaluationStatusType,
).map(([key, value]) => {
  return { value: Number(key), title: value }
})

export const BuyerEvaluationStatusOptions: Options = Object.entries(
  BuyerEvaluationStatusType,
).map(([key, value]) => {
  return { value: Number(key), title: value }
})

export const ImprovementPlanActionStatusOptions = strictObjectEntries(
  ImprovementPlanActionStatusType,
).map(([key, value]) => {
  return { value: Number(key) as InferNumber<typeof key>, title: value } satisfies Options[number]
})

export const BuyerCreateQuestionGroupAnswerStatusOptions = strictObjectEntries(
  BuyerCreateQuestionGroupAnswerStatusType,
).map(([key, value]) => {
  return { value: Number(key) as InferNumber<typeof key>, title: value } satisfies Options[number]
})

export const industryOptionsAdmin: Options = Object.entries(
  IndustryTypeAdmin,
).map(([key, value]) => {
  return { value: Number(key), title: value }
})
export const prefectureOptions: Options = Object.entries(PrefectureName).map(
  ([key, value]) => {
    return { value: Number(key), title: value }
  },
)
export const sustainaRatingOptions: Options = Object.entries(
  SUSTAINA_RATINGS,
).map(([key, value]) => {
  return { value: Number(key), title: value }
})

export const priorityForAdminOptions = strictObjectEntries(
  PriorityTypeAdmin,
).map(([key, value]) => {
  return { value: Number(key), title: value }
})

export const EsgDataTypeOptions = strictObjectEntries(
  ESG_DATA_TYPE,
).map(([_, value]) => {
  return {
    value: value.key,
    title: value.title,
    description: value.description,
    questionCount: value.questionCount,
  }
})

export const EsgDataSharingStatusOptions = strictObjectEntries(
  ESG_DATA_SHARING_STATUS,
).map(([key, value]) => {
  return { value: EsgDataStatus[key as keyof typeof EsgDataStatus], title: value }
})

export const EsgDataSharedStatusOptions = strictObjectEntries(
  ESG_DATA_SHARED_STATUS,
).map(([key, value]) => {
  return { value: EsgDataStatus[key as keyof typeof EsgDataStatus], title: value }
})

export const EsgDataAnsweringStatusOptions = strictObjectEntries(
  ESG_DATA_ANSWERING_STATUS,
).map(([key, value]) => {
  return { value: EsgDataStatus[key as keyof typeof EsgDataStatus], title: value }
})
